import { useState } from 'react';
import { Settings, Eye, Wrench, Shield, Upload, UserX, Users, Palette, CalendarSync, Lock } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import SectionVisibilityTab from './SectionVisibilityTab';
import MaintenanceModeTab from './MaintenanceModeTab';
import GlobalAdminsTab from './GlobalAdminsTab';
import BulkUploadTab from './BulkUploadTab';
import RegistrationTab from './RegistrationTab';
import CommunitySectionTab from './CommunitySectionTab';
import BrandingTab from './BrandingTab';
import InvestOttawaEventsTab from './InvestOttawaEventsTab';
import SiteAccessTab from './SiteAccessTab';

const GlobalSettingsPage = () => {
  const [activeTab, setActiveTab] = useState('sections');

  return (
    <div className="w-full">
        {/* Fixed Header */}
        <div className="fixed top-[var(--header-height)] left-[var(--sidebar-width)] right-0 z-30 bg-white dark:bg-sidebar-active transition-all duration-300 border-b border-gray-200 dark:border-gray-700">
          <div className="px-4 py-3">
            <div className="flex items-center gap-3">
              <Settings className="h-7 w-7 text-primary" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Global Settings</h1>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">
              Manage platform-wide settings that affect the entire application
            </p>
          </div>
          {/* Tabs nav */}
          <div className="px-4 pb-0 border-t border-gray-100 dark:border-gray-700/50 bg-sidebar-hover">
            <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
              <TabsList className="grid w-full grid-cols-4 lg:grid-cols-9 lg:w-auto lg:inline-grid">
                <TabsTrigger value="branding" className="flex items-center gap-2">
                  <Palette className="h-4 w-4" />
                  <span className="hidden sm:inline">Branding</span>
                  <span className="sm:hidden">Theme</span>
                </TabsTrigger>
                <TabsTrigger value="sections" className="flex items-center gap-2">
                  <Eye className="h-4 w-4" />
                  <span className="hidden sm:inline">Section Visibility</span>
                  <span className="sm:hidden">Sections</span>
                </TabsTrigger>
                <TabsTrigger value="maintenance" className="flex items-center gap-2">
                  <Wrench className="h-4 w-4" />
                  <span className="hidden sm:inline">Maintenance Mode</span>
                  <span className="sm:hidden">Maintenance</span>
                </TabsTrigger>
                <TabsTrigger value="site-access" className="flex items-center gap-2">
                  <Lock className="h-4 w-4" />
                  <span className="hidden sm:inline">Site Access</span>
                  <span className="sm:hidden">Access</span>
                </TabsTrigger>
                <TabsTrigger value="bulk-upload" className="flex items-center gap-2">
                  <Upload className="h-4 w-4" />
                  <span className="hidden sm:inline">Bulk Upload</span>
                  <span className="sm:hidden">Upload</span>
                </TabsTrigger>
                <TabsTrigger value="registration" className="flex items-center gap-2">
                  <UserX className="h-4 w-4" />
                  <span className="hidden sm:inline">Registration</span>
                  <span className="sm:hidden">Signup</span>
                </TabsTrigger>
                <TabsTrigger value="community" className="flex items-center gap-2">
                  <Users className="h-4 w-4" />
                  <span className="hidden sm:inline">Community</span>
                  <span className="sm:hidden">Community</span>
                </TabsTrigger>
                <TabsTrigger value="integrations" className="flex items-center gap-2">
                  <CalendarSync className="h-4 w-4" />
                  <span className="hidden sm:inline">Invest Ottawa</span>
                  <span className="sm:hidden">IO Events</span>
                </TabsTrigger>
                <TabsTrigger value="admins" className="flex items-center gap-2">
                  <Shield className="h-4 w-4" />
                  <span className="hidden sm:inline">Global Admins</span>
                  <span className="sm:hidden">Admins</span>
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
        </div>

        {/* Content - offset to clear fixed header (title ~5rem + tabs ~2.5rem) */}
        <div className="pt-[7.5rem]">
          {activeTab === 'branding' && <BrandingTab />}
          {activeTab === 'sections' && <SectionVisibilityTab />}
          {activeTab === 'maintenance' && <MaintenanceModeTab />}
          {activeTab === 'site-access' && <SiteAccessTab />}
          {activeTab === 'bulk-upload' && <BulkUploadTab />}
          {activeTab === 'registration' && <RegistrationTab />}
          {activeTab === 'community' && <CommunitySectionTab />}
          {activeTab === 'integrations' && <InvestOttawaEventsTab />}
          {activeTab === 'admins' && <GlobalAdminsTab />}
        </div>
      </div>
  );
};

export default GlobalSettingsPage;



